<mat-list-item>
  <mat-icon matListItemIcon>timelapse</mat-icon>
  <span matListItemTitle>
    <div class="capitalize">{{ status$ | ngrxPush }}</div>
  </span>
</mat-list-item>
